import join from 'url-join';
import { AUTH_HEADERS, coreFetch, isLocaleCA, MIME_TYPE } from '@libs/core';
import { getENV } from '@libs/common-next/utils';

type API_PROXY_CLIENT_TYPE = 'cwea' | 'identity';

function getCweaBaseUrl() {
    if (IS_SSR) return getENV('CWEA_PROXY_URL');

    return isLocaleCA() ? getENV('NEXT_PUBLIC_CWEA_PROXY_URL_CA') : getENV('NEXT_PUBLIC_CWEA_PROXY_URL_US');
}

function getIdentityApiBaseUrl() {
    if (IS_SSR) return getENV('IDENTITY_API_PROXY_URL');

    return isLocaleCA()
        ? getENV('NEXT_PUBLIC_IDENTITY_API_PROXY_URL_CA')
        : getENV('NEXT_PUBLIC_IDENTITY_API_PROXY_URL_US');
}

function getBaseUrlFromType(type: API_PROXY_CLIENT_TYPE) {
    if (type === 'cwea') return getCweaBaseUrl();
    return getIdentityApiBaseUrl();
}

function createApiProxyClient(type: API_PROXY_CLIENT_TYPE) {
    return async <T>(
        pathname: string,
        ...args: Parameters<typeof coreFetch> extends [unknown, ...infer Rest] ? Rest : never
    ) => {
        const securityHeader = IS_SSR
            ? {
                  [AUTH_HEADERS.X_VERCEL_PROECTION_BYPASS]: getENV('VERCEL_AUTOMATION_BYPASS_SECRET'),
              }
            : {};
        const [init = {}, ...rest] = args;

        const defaultContentType = init.body instanceof FormData ? {} : { [AUTH_HEADERS.CONTENT_TYPE]: MIME_TYPE.json };

        const ephemeralEnv = getENV('NEXT_PUBLIC_EPHEMERAL');

        const combinedInit = {
            cache: 'no-store',
            ...init,
            headers: {
                ...defaultContentType,
                ...securityHeader,
                ...init.headers,
                ...(ephemeralEnv && { 'petm-eph-env': ephemeralEnv }),
            },
        } as typeof init;

        // Supporting only strings for simplicity. Can be extended if needed
        const inputString = join(getBaseUrlFromType(type), pathname);
        return await coreFetch<T>(inputString, combinedInit, ...rest);
    };
}

export const client = {
    cwea: createApiProxyClient('cwea'),
    identity: createApiProxyClient('identity'),
};
